module.exports = __webpack_public_path__ + "img/post-sports-1.31d7ecb5.jpg";